import * as React from 'react'
import { useBulkActionContext } from '../BulkActionContext'
import { BulkActionSidebars } from '../typings'

type Props = {
  bulkActionSidebars?: BulkActionSidebars
}

export const BulkActionsSidebar: React.FC<Props> = (props) => {
  const { bulkActionSidebars: sidebars } = props
  const {
    state: { activeBulkAction },
  } = useBulkActionContext()

  const Component = React.useMemo(
    () =>
      (sidebars && activeBulkAction && sidebars[activeBulkAction]) ??
      React.Fragment,
    [activeBulkAction, sidebars],
  )

  return sidebars && activeBulkAction ? <Component /> : null
}
BulkActionsSidebar.displayName = 'BulkActionsSidebar'
